module.exports = __webpack_public_path__ + "static/img/bg.ddef36c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/feature6/bg.jpg
// module id = Odq1
// module chunks = 7